import { AxiosInstance } from "../utils/AxiosInstance";

export const getMembershipDetails = async (membershipId: string) => {
  const { data } = await AxiosInstance.get(
    `/v1/memberships/${membershipId}/details`
  );
  return data;
};

export const cancelMembership = async (membershipId: string) => {
  await AxiosInstance.put(`/v1/memberships/${membershipId}/cancel`);
};

export const activateMembership = async (membershipId: string) => {
  await AxiosInstance.put(`/v1/memberships/${membershipId}/activate`);
};

export const getMembershipPlans = async () => {
  const { data } = await AxiosInstance.get(`/v1/memberships/plans`);
  return data;
};

export const updateMembership = async (
  membershipId: string,
  plan: string,
  card: string
) => {
  const { data } = await AxiosInstance.post(
    `/v1/memberships/${membershipId}/update`,
    {
      plan,
      card,
    }
  );
  return data;
};
